import * as React from 'react';
import { wrapDisplayName } from '@cian/react-utils';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { formContextObj } from '../FormContainer';
import { useFormTracking } from '../../utils/useFormTracking';
import { useSubmitBtnText } from './utils/useSubmitBtnText';

/**
 * HOC оборачивает контейнер вопроса, превращая его в последний вопрос
 * Добавляет сабмит формы при нажатии на кнопку сабмита шага
 * Пробрасывает поля ошибки, прелоадера и текста кнопки в контейнер вопроса
 *  */
export const withFinalStep = (
  Component: React.ComponentType<React.PropsWithChildren<IBaseQuestionProps>>,
): React.ComponentType<React.PropsWithChildren<IBaseQuestionProps>> => {
  const Wrapper: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
    const {
      question: { required, answerField },
    } = props;

    const { quizSubmitError, quizSubmitting, handleCompleteQuiz, questionsMap, stepsMap, stepsHistory } =
      React.useContext(formContextObj);

    const { trackSubmit, trackFormSendEvent } = useFormTracking();

    /** Обертка над setNextStep добавляет сабмит всей формы */
    const setNextStepWithSubmit: IBaseQuestionProps['setNextStep'] = async answersCollection => {
      try {
        /** @see useQuizCompleteControls.ts */
        await handleCompleteQuiz(
          {
            answersState: answersCollection,
            questionsMap,
            stepsMap,
            stepsHistory,
          },
          props.setNextStep.bind(null, answersCollection),
        );

        trackFormSendEvent();
      } catch {
        trackSubmit({
          isRequired: required,
          field: answerField,
          value: 'submit error',
        });
      }
    };

    const submitButtonText = useSubmitBtnText(props);

    return (
      <Component
        {...props}
        setNextStep={setNextStepWithSubmit}
        submitButtonText={submitButtonText}
        showButtonPreloader={quizSubmitting}
        error={quizSubmitError || undefined}
      />
    );
  };

  Wrapper.displayName = wrapDisplayName(Wrapper, 'withFinalStep');

  return Wrapper;
};
